'use client';
import { useYmm20 } from '@/hooks/useYmm';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { requestYmmModal } from '@/packages/sxm/ymm/ymmModalEvent';
import styles from './navYmm.module.scss';

export default function NavYMM() {
    const { ymmTextBar } = useYmm20();

    return (
        <Grid container className={styles.containerWrapper}>
            <Grid className={styles.container} col={{ sm: 12 }}>
                <span className={styles.ymmTextWrapper} data-cy="nav_ymm-display">
                    Showing channels for my
                    <span className={styles.selection}> {ymmTextBar}</span>.{' '}
                    <button className={styles.editButton} onClick={() => requestYmmModal()}>
                        Edit
                    </button>
                </span>
            </Grid>
        </Grid>
    );
}
